// import { Grid } from 'antd';
import { ContentFilters, ContentTopBar } from 'components';
import { CategoryFilterForm } from 'features/master-management/components/filter-field/category-filter-form';
import { CategoryFormFilterValues } from 'features/master-management/components/filter-field/type';
import { EditCategoryViewModal } from 'features/master-management/components/modal/category-edit-view';
import { useState } from 'react';
// const { useBreakpoint } = Grid;

type RoleProps = {
  setEditModal: any;
  editModal: boolean;
  editData: any;
  handleFilter: (values: CategoryFormFilterValues) => void;
  getInitialFilter: CategoryFormFilterValues;
};

export const CategoryTopBar = ({
  setEditModal,
  editModal,
  editData,
  handleFilter,
  getInitialFilter,
}: RoleProps) => {
  useState<any>();
  // const [showAddModal, setShowAddModal] = useState(false);
  // const screens = useBreakpoint();
  const formId = 'role-filters-form';

  return (
    <>
      <ContentTopBar
        title={'Category List'}
        renderButtons={
          <>
            {/* <Button
              icon={!screens.xs ? <PlusOutlined /> : undefined}
              onClick={() => setShowAddModal(true)}
              style={{ backgroundColor: '#223666', color: 'white' }}
            >
              Add New Category
            </Button>
            {showAddModal && (
              <AddCategoryModal onClose={() => setShowAddModal(false)} />
            )} */}
            {editModal && (
              <EditCategoryViewModal
                onClose={() => setEditModal(false)}
                editData={editData}
              />
            )}
          </>
        }
      />
      <ContentFilters formId={formId}>
        <CategoryFilterForm
          formId={formId}
          handleFilter={handleFilter}
          initialValues={getInitialFilter}
        />
      </ContentFilters>
    </>
  );
};
